import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  CardMedia,
  Toolbar,
  Typography,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import WorkIcon from "@mui/icons-material/Work";
import TaskIcon from "@mui/icons-material/Task";
import ChatIcon from "@mui/icons-material/Chat";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import logo from "../imgs/logo_border.png";

// Todos los botones de navegación (los que antes estaban repartidos entre la
// AppBar superior y la BottomNav).
const NAV_ITEMS = [
  { path: "/home", label: "Inicio", Icon: HomeIcon },
  { path: "/members", label: "Buscar", Icon: SearchIcon },
  { path: "/publish", label: "Publicar", Icon: AddCircleIcon },
  { path: "/workspace", label: "Workspace IA", Icon: AutoAwesomeIcon },
  { path: "/proyectos", label: "Mis Proyectos", Icon: WorkIcon },
  { path: "/propuestas", label: "Mis Propuestas", Icon: TaskIcon },
  { path: "/chats", label: "Chats", Icon: ChatIcon },
  { path: "/notifications", label: "Notificaciones", Icon: NotificationsIcon },
  { path: "/profile", label: "Perfíl", Icon: AccountCircleIcon },
];

const Sidebar = ({ width = 240 }) => {
  const location = useLocation();

  return (
    <Drawer
      variant="permanent"
      sx={{
        width,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width,
          boxSizing: "border-box",
          borderRight: (theme) => `1px solid ${theme.palette.divider}`,
        },
      }}
    >
      <Toolbar
        sx={{
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: 2,
          minHeight: "auto !important",
        }}
      >
        <CardMedia
          component="img"
          image={logo}
          title="Skach"
          sx={{ width: 120, height: "auto", objectFit: "contain" }}
        />
        <Typography
          variant="caption"
          align="center"
          sx={{ mt: 1, color: "text.secondary", lineHeight: 1.3 }}
        >
          ¡Crea un proyecto o busca uno!
        </Typography>
      </Toolbar>

      <Box sx={{ overflowY: "auto" }}>
        <List sx={{ px: 1 }}>
          {NAV_ITEMS.map(({ path, label, Icon }) => {
            const active = location.pathname.startsWith(path);
            return (
              <ListItemButton
                key={path}
                component={RouterLink}
                to={path}
                selected={active}
                sx={{
                  borderRadius: 1,
                  mb: 0.5,
                  color: active ? "primary.main" : "text.primary",
                  "& .MuiListItemIcon-root": {
                    color: active ? "primary.main" : "text.secondary",
                    minWidth: 40,
                  },
                }}
              >
                <ListItemIcon>
                  <Icon />
                </ListItemIcon>
                <ListItemText
                  primary={label}
                  primaryTypographyProps={{
                    fontWeight: active ? 600 : 400,
                  }}
                />
              </ListItemButton>
            );
          })}
        </List>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
